<template>
  <div class="wrapper">
    <div
      class="profile-field__title"
      :class="{
        'profile-field__title--required': field.required,
      }"
    >
      {{ field.name }}
    </div>
    <div v-if="preview" class="preview">
      <div class="file-preview">
        <file-preview :type="'doc'" name="Документ 1.docx" data-type="link"></file-preview>
        <c-button
          v-b-popover.html="{
            container: '#app',
            trigger: 'hover blur',
            content: 'Удалить',
            placement: 'top',
          }"
          :disabled="true"
          class="file-preview__remove"
          size="iconic"
          icon="trash"
        />
      </div>
    </div>
    <file-loader
      ref="loader"
      v-model="files"
      :links="links"
      format="images,pdf,docs"
      actions="loadFiles,preview"
      :limit="field.maxFiles || 10"
      :disabled="preview"
      @changeLinks="updateLinks"
    ></file-loader>

    <error-feedback v-if="error" :text="error" />
  </div>
</template>

<script>
import FileLoader from "@/components/file-loader";
import FilePreview from "@/components/file-preview";
import CButton from "@/components/controls2/Button";
import ErrorFeedback from "@/components/error-feedback";

export default {
  components: { FileLoader, FilePreview, CButton, ErrorFeedback },
  props: ["field", "value", "preview", "editable", "error"],
  data() {
    return {
      inited: false,
      files: [],
      links: [],
    };
  },
  watch: {
    files() {
      this.updateValue();
    },

    value(v) {
      this.setData(v);
    },
  },
  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      const { files, oldFiles } = value;

      if (!files || !files.length && this.files.length) {
        if (this.$refs.loader) {
          this.$refs.loader.clearFiles();
        }
      }

      const currentLinks = this.links.map((link) => link.id);
      const newLinks = (oldFiles || []).map((file) => file.id);

      if (JSON.stringify(currentLinks) !== JSON.stringify(newLinks)) {
        this.links = oldFiles || [];
      }
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateLinks(value) {
      this.links = value;
      this.updateValue();
    },
    updateValue() {
      this.$emit("input", {
        files: this.files,
        oldFiles: this.links,
      });
      if (this.inited) this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
.profile-field {
  &__title {
    font-size: 15px;
  }
}
.preview {
  margin-bottom: 20px;
  display: flex;
}
.file-preview {
  position: relative;

  &__remove {
    position: absolute;
    right: -30px;
    top: -4px;
  }
}
</style>
